import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["as", "children", "color"];
import { BodySmall } from './BodySmall';
import { jsx as _jsx } from "react/jsx-runtime";
export const Caption = _ref => {
  let {
      as = 'div',
      children,
      color = 'light'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(BodySmall, Object.assign({}, rest, {
    as: as,
    color: color,
    children: children
  }));
};